//*********************     AUTH ACTIONS    ****************************** */


export const SET_LOGIN_ON_LOCALSTORAGE_SUCCESS = 'SET_LOGIN_ON_LOCALSTORAGE_SUCCESS'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
